export interface UserCountry {
  country: string;
  ip: string | null;
  success: boolean;
}
